import { Option } from "./unitOptions";

export const PACKAGING_OPTIONS: Option[] = [
  { id: 1, name: "Box" },
  { id: 2, name: "Bottle" },
  { id: 3, name: "Packet" },
  { id: 4, name: "Can" },
  { id: 5, name: "Roll" },
  { id: 6, name: "Bag" },
  { id: 7, name: "Jar" },
  { id: 8, name: "Sachet" },
  { id: 9, name: "Carton" },
  { id: 10, name: "Pouch" },
  { id: 11, name: "Tin" },
];
